import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import convertMsToHumanTime from '../../../../services/mini/convertMsToHumanTime';
import { AnalyticsPopupTile } from '../AnalyticsPopupTile/AnalyticsPopupTile';
import { AnalyticsSimpleTile } from '../AnalyticsSimpleTile/AnalyticsSimpleTile';
import { BarChartVerticalWrapper } from '../../../components/Charts/BarChartVerticalWrapper';
import NoDataChart from '../../../components/Charts/NoDataChart';
import { getBarChartGradients } from '../../../components/Charts/getBarChartGradients';
import convertMsForYAxis from '../../../../services/mini/convertMsForYAxis';
import composedChartColors from '../../../../const/composedChartColors';
import { AnalyticsSimpleTileCollapser } from '../AnalyticsSimpleTile/AnalyticsSimpleTileCollapser';

class AnalyticsMicSessionsBarChartTile extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.showData = this.showData.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.report?.data?.chartsDataUpdateTs !== nextProps.report?.data?.chartsDataUpdateTs) {
            return true;
        }
        if (JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)) {
            return true;
        }
        return false;
    }

    showData() {
        console.info('AnalyticTile DATA', this.props);
    }

    render() {
        const {
            environment,
            report
        } = this.props;

        const chartData = report?.data?.micSessionStats?.chartData;

        return (
            <AnalyticsSimpleTile {...this.props} >
                <div
                    className={`analytic-tile ${environment}`}
                    onClick={this.showData}>
                    <AnalyticsSimpleTileCollapser {...this.props}>
                        <div className="analytic-tile_header">
                            Session Time
                        </div>
                    </AnalyticsSimpleTileCollapser>
                    <div className="analytic-tile_legend">
                        <div className="analytic-tile_legend-dot-1" /> Session Time: <span className="analytic-tile_total">{chartData?.length > 0 ? convertMsToHumanTime(chartData?.reduce((acc, b) => acc + b.connectedMs, 0)) : '—'}</span>
                        <div className="analytic-tile_legend-dot-2" />  Mic Time: <span className="analytic-tile_total">{chartData?.length > 0 ? convertMsToHumanTime(chartData?.reduce((acc, b) => acc + b.listenMs, 0)) : '—'}</span>
                    </div>
                    <div className="analytic-tile_body">
                        <BarChartVerticalWrapper>
                            {chartData?.length > 0 ?
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart data={chartData}>
                                        {getBarChartGradients()}
                                        <CartesianGrid strokeDasharray="1 3" vertical horizontal />
                                        <XAxis dataKey="name" />
                                        <YAxis
                                            dataKey="connectedMs"
                                            scale="sqrt"
                                            tickFormatter={(str) => {
                                                return convertMsForYAxis(str, true, true);
                                            }} />
                                        <Tooltip content={<MicSessionsTooltip environment={environment} />} />
                                        <Bar dataKey="connectedMs" fill={`url(#${environment}ColorVerticalExternal)`} />
                                        <Bar dataKey="listenMs" fill={`url(#${environment}ColorVerticalInternal)`} />
                                    </BarChart>
                                </ResponsiveContainer> :
                                <NoDataChart data={chartData} />}
                        </BarChartVerticalWrapper>
                    </div>
                </div>
            </AnalyticsSimpleTile>
        );
    }
}

function MicSessionsTooltip({ active, payload, environment }) {
    let data;
    let internalValStyle = {};
    let externalValStyle = {};
    if (environment) {
        internalValStyle = { backgroundColor: composedChartColors[environment][0] };
        externalValStyle = { backgroundColor: composedChartColors[environment][1] };
    }

    if (active && payload && payload.length) {
        data = payload[0].payload;
        return (
            <div className="stats-tooltip">
                <div className="stats-tooltip_time">
                    {data.name}
                </div>
                <div>
                    <span className="tooltip-legend-rect" style={externalValStyle}></span><span className="tooltip-legend">Session Time: {convertMsToHumanTime(data.connectedMs)}</span><br />
                    <span className="tooltip-legend-rect" style={internalValStyle}></span><span className="tooltip-legend">Mic. Time: {convertMsToHumanTime(data.listenMs)}</span>
                </div>
            </div>
        );
    }
    return null;
}

export default AnalyticsPopupTile(AnalyticsMicSessionsBarChartTile);
